import { useLanguage } from "@/i18n";
import { TreePine } from "lucide-react";

export default function Marquee() {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="py-2.5 overflow-hidden border-y border-amber-300/40 bg-gradient-to-r from-[#B8860B] via-[#E5C15D] to-[#B8860B]" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee gap-0 hover:[animation-play-state:paused]">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-5 px-5 whitespace-nowrap">
            <span className="font-display font-bold text-xs sm:text-sm tracking-[0.18em] text-[#3D2E05] uppercase">{item}</span>
            <TreePine size={13} className="text-[#5C4408] shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
